// extracted by mini-css-extract-plugin
export default {"Container":"UploadPicture_Container__XEJ++","Loading":"UploadPicture_Loading__1NBFY"};